import { render, staticRenderFns } from "./footerClient.vue?vue&type=template&id=4b522341&"
import script from "./footerClient.vue?vue&type=script&lang=js&"
export * from "./footerClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports